import React, { useEffect } from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { createStyles, Grid, makeStyles, Typography } from '@material-ui/core';

import AntSwitch from '../EditEquipmentModal/AntSwitch';
import { TCommodityCategory } from '../../types/commodity';
import { useCategoryStrings } from './constants/useCategoryStrings';
import { useTranslation } from 'react-i18next';
/**
 *
 *
 */

const useStyles = makeStyles(theme =>
  createStyles({
    container: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    switchWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
  }),
);

interface CommodityCategoryProps {
  region?: string;
  category: TCommodityCategory;
  onChange: (category: TCommodityCategory) => void;
  readOnly?: string[];
}

/**
 * Form for category and product sheets.
 * @param category
 * @param onChange
 * @constructor
 */
export default function CommodityCategory({
  category,
  onChange,
}: CommodityCategoryProps) {
  const classes = useStyles();
  const CategoryStrings = useCategoryStrings();
  const { t } = useTranslation();
  const { commodity } = useSelector(
    (state: RootStateOrAny) => state.CommodityGroupsReducer,
  );

  useEffect(() => {
    onChange({
      ...category,
      isParent: Boolean(category.isParent),
      categoryName: commodity.categoryName || '',
      subCategoryName: commodity?.subCategoryName || '',
    });
  }, [commodity]);

  const handleSwitchIsParent = () => {
    onChange({ ...category, isParent: !category.isParent });
  };

  return (
    <Grid item xs={12} className={classes.container}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={2} className={classes.switchWrapper}>
          <Typography>{CategoryStrings.is_parent}</Typography>
          <AntSwitch
            checked={category.isParent}
            name="isParent"
            onChange={handleSwitchIsParent}
          />
        </Grid>
        <Grid item xs={3}>
          <Typography>
            {[
              t('equipment.category', CategoryStrings.category),
              category.isParent
                ? commodity?.psGroupData?.PsBaseName ||
                  t('app.common.label.not_defined', 'Not defined')
                : commodity.categoryName ||
                  t('app.common.label.not_defined', 'Not defined'),
            ].join(': ')}
          </Typography>
        </Grid>
        {!category.isParent && (
          <Grid item xs={4}>
            <Typography>
              {[
                t('commodity.subCategory', CategoryStrings.subcategory),
                commodity.subCategoryName ||
                  t('app.common.label.not_defined', 'Not defined'),
              ].join(': ')}
            </Typography>
          </Grid>
        )}
        <Grid item xs={3}>
          <Typography>
            {[
              t('commodity.production_id', CategoryStrings.production_id),
              commodity?.psGroupData?.friendlyNameGroupId ||
                t('app.common.label.not_defined', 'Not defined'),
            ].join(': ')}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
